import { useForm } from '../../../../../shared/form/useForm';
import { useVehicleFormSchema } from './useVehicleFormSchema';

export function useVehicleForm() {
	const vehicleFormSchema = useVehicleFormSchema();

	const form = useForm({
		mode: 'onSubmit',
		validationSchema: vehicleFormSchema,
	});

	return form;
}
